export default __webpack_public_path__ + "static/media/hht2_ep20_speaking_02.8062ab4c.png";